module.exports = __webpack_public_path__ + "839e0b2681200bae279e58364f5612e2.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/unleash_giants_2-420.webp
// module id = 579
// module chunks = 0